import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuLink } from '../ui/navigation-menu';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="w-full py-3 md:py-4 px-4 md:px-6 flex items-center justify-between border-b border-border/40 glass fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm">
      <Link to="/" className="focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg">
        <Logo />
      </Link>
      
      <>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6">
          <NavigationMenu>
            <NavigationMenuList className="flex items-center gap-1">
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link to="/features" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-2">
                    Features
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link to="/pricing" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-2">
                    Pricing
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink asChild>
                  <Link to="/about" className="text-sm font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-2">
                    About
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>

          <div className="flex items-center gap-4">
            <Link to="/login">
              <Button variant="ghost">Sign In</Button>
            </Link>
            <Link to="/signup">
              <Button>Get Started</Button>
            </Link>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden p-2 rounded-lg hover:bg-accent/50 transition-colors"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="fixed inset-0 top-[60px] bg-background/95 backdrop-blur-sm md:hidden z-50">
            <div className="flex flex-col p-4 space-y-4">
              <Link
                to="/features"
                className="text-base font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-3 rounded-lg hover:bg-accent/50"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Features
              </Link>
              <Link
                to="/pricing"
                className="text-base font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-3 rounded-lg hover:bg-accent/50"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Pricing
              </Link>
              <Link
                to="/about"
                className="text-base font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-3 rounded-lg hover:bg-accent/50"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </Link>
              <div className="pt-4 border-t border-border/40">
                <Link
                  to="/login"
                  className="block w-full text-center text-base font-medium text-foreground/80 hover:text-foreground transition-colors px-4 py-3 rounded-lg hover:bg-accent/50"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Sign In
                </Link>
                <Link
                  to="/signup"
                  className="block w-full text-center text-base font-medium bg-primary text-primary-foreground hover:bg-primary/90 transition-colors px-4 py-3 rounded-lg mt-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Get Started
                </Link>
              </div>
            </div>
          </div>
        )}
      </>
    </header>
  );
};

export default Header;
